<h3>{{ isFormEnabled ? "Enter Report Criteria" : "Report Criteria Review" }}</h3>
<div class="padding">
  <form [formGroup]="searchCriteriaDetails">
    @if (order.businessReportCriteria?.businessName || this.uiConfiguration.businessReportDetailsConfiguration?.showBusinessName;) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.exactNameAsItIsRegistered' | transloco }}</mat-label>
            <input matInput [formControlName]="'name'" data-testid="business-name-field"
              [placeholder]="'orders.exactNameAsItIsRegistered' | transloco"
              [value]="order.businessReportCriteria?.businessName ?? ''">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('name')!"
          [message]="nameError$"></lib-error-bubble>
        </div>
      </div>
    }
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{this.uiConfiguration.businessReportDetailsConfiguration?.businessNumberHint!}}</mat-label>
          <input matInput [formControlName]="'number'" data-testid="business-number-field" [placeholder]="this.uiConfiguration.businessReportDetailsConfiguration?.businessNumberHint ?? ''">
        </mat-form-field>
        <lib-error-bubble [control]="searchCriteriaDetails.get('number')!"
        [message]="numberError$"></lib-error-bubble>
      </div>
    </div>
    @if (order.businessReportCriteria?.address || this.uiConfiguration.businessReportDetailsConfiguration?.showAddress) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.address' | transloco }}</mat-label>
            <input matInput [formControlName]="'address'" data-testid="business-address-field" [placeholder]="'common.labels.address' | transloco">
          </mat-form-field>
          <lib-error-bubble [control]="searchCriteriaDetails.get('address')!"
          [message]="addressError$"></lib-error-bubble>
        </div>
      </div>
    }
  </form>
</div>